import { ServerResponse } from 'http'
import { constants } from '@dustin-web/microsite-config/src/constants'
import cookie from 'cookie'
import Cookies from 'universal-cookie'
import { NextApiRequest, NextApiResponse } from 'next'
import { ExpressLikeRequestContext } from '@dustin-web/microsite-config/src'

const SET_COOKIE_HEADER = 'Set-Cookie'

export const cookieFactory = (req: ExpressLikeRequestContext, res: ServerResponse) => {
  const cookies = new Cookies(req.headers.cookie).getAll() as { [key: string]: string }

  const setCookie = (name: string, value: string, opts: cookie.CookieSerializeOptions) => {
    res.setHeader(SET_COOKIE_HEADER, [
      ...((res.getHeader(SET_COOKIE_HEADER) as string[]) || []),
      cookie.serialize(name, value, opts),
    ])
  }

  const clearCookie = (name: string, options = {}) => {
    res.setHeader(SET_COOKIE_HEADER, [
      ...((res.getHeader(SET_COOKIE_HEADER) as string[]) || []),
      cookie.serialize(name, '', {
        path: '/',
        ...options,
        maxAge: -1,
      }),
    ])
  }

  return { cookies, setCookie, clearCookie }
}

export const withoutLeadingAndTrailingSlashes = (path: string) =>
  path.replace(/^\s*\/*\s*|\s*\/*\s*$/gm, '')

export const getBasePath = (req: ExpressLikeRequestContext) => {
  const path = withoutLeadingAndTrailingSlashes(req.path || '')

  const pathParts = path.split('/')

  const firstPathFromRequest = pathParts[0]
  const forwarededBasePath = withoutLeadingAndTrailingSlashes(
    req.header ? req.header(constants.dustinHeaders.forwardedBasePath) || '' : ''
  )

  const basePath = forwarededBasePath || firstPathFromRequest

  return {
    basePath: `/${basePath}`,
    routeTo: `/${path}`,
  }
}

export function checkStringBoolean<TDefaultValue>(
  value: string | null | undefined,
  defaultValue: TDefaultValue
) {
  if (value?.toLocaleLowerCase() === 'true') {
    return true
  }

  if (value?.toLocaleLowerCase() === 'false') {
    return false
  }

  return defaultValue
}

export function runApiMiddleware(req: NextApiRequest, res: NextApiResponse, fn: any) {
  return new Promise((resolve, reject) => {
    fn(req, res, (result: any) => {
      if (result instanceof Error) {
        return reject(result)
      }

      return resolve(result)
    })
  })
}
